import React from 'react';
import {STDPage, BoxFooter, DivFooter, StdText, StdLine} from './style';


const Footer = () => {
  let year = new Date().getFullYear();

  return (
    <>
      <STDPage>
        <BoxFooter>
          <DivFooter>
            <StdLine>
              <StdText>© Volkswagen {year}</StdText>
            </StdLine>
          </DivFooter>
        </BoxFooter>
      </STDPage>
    </>
  );
};

export default Footer;
